<template>
  <div class="listUsers">
    <div class="info-member">
      <img src="@/assets/RSS.svg" class="can-post" v-if="isCommunityBroadcast && isUserBroadcaster" />
      <user-link :user="user" :is-broadcaster="isCommunityBroadcast && isUserBroadcaster" />
    </div>
    <div id="menu" :class="showMenu ? 'down' : ''" v-if="isCurentUserOwner()">
      <div class="action" v-click-outside="hide" @click="toggleMenu()" v-if="!isUserOwner()">
        <img src="@/assets/Dots.svg" />
      </div>
      <ul id="list">
        <li>
          <grant-user-for-broadcast
            v-if="isCommunityBroadcast"
            :community-id="communityDetail.idCommunity"
            :user-id="user.id" :is-broadcaster="isUserBroadcaster"
          />
        </li>
        <li>
          <grant-user-for-ownership
            :community-id="communityDetail.idCommunity"
            :user-id="user.id"
          />
        </li>
        <li v-if="communityDetail.community.type === 'private'">
          <remove-user-from-community
            :community-id="communityDetail.idCommunity"
            :user-id="user.id"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import UserLink from '@/components/shared/UserLink'
import GrantUserForBroadcast from './GrantUserForBroadcast'
import GrantUserForOwnership from './GrantUserForOwnership'
import RemoveUserFromCommunity from './RemoveUserFromCommunity'
import ClickOutside from 'vue-click-outside'
import { mapState } from 'vuex'

export default {
  name: 'CommunityMember',
  components: { GrantUserForBroadcast, UserLink, GrantUserForOwnership, RemoveUserFromCommunity },
  directives: {
    ClickOutside
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showMenu: false
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    hide() {
      this.showMenu = false
    },
    isCurentUserOwner() {
      return this.communityDetail.owner.id === this.$store.getters.currentUserId
    },
    isUserOwner() {
      return this.communityDetail.owner.id === this.user.id
    }
  },
  computed: {
    isUserBroadcaster() {
      const index = this.communityDetail.members.findIndex(m => m.id === this.user.id)
      return this.communityDetail.members[index]['communities.UserCommunity.isAllowedToPost']
    },
    isCommunityBroadcast() {
      return this.communityDetail.community.isBroadcast
    },
    ...mapState({
      communityDetail: state => state.community.communityDetail
    })
  }
}
</script>

<style scoped lang="scss">
.listUsers {
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: relative;
    font-size: 14px;

    .info-member {
      display: flex;

      .can-post {
        width: 10px;
        height: 10px;
        position: absolute;
        left: 2px;
      }

      .liker-photo {
          height: 32px;
          width: 32px;
          padding: 6px 0 6px 12px;
          border-radius: 100%;
      }

      .liker-names {
          padding: 11px 0 12px 8px;
          height: 21px;
      }

      .liker-names:hover {
          cursor: pointer;
      }

    }

    .action {
      margin: auto 0 auto 0;
    }

    .action:hover {
      cursor: pointer;
    }

    #menu {
      margin: 0 1rem;
      display: flex;
      justify-content: flex-end;
    }

    .menu-button {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 16px;
      cursor: pointer;
    }

    #menu #list {
      max-width: 210px;
      transition: max-height 0.15s ease-out;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      list-style-type: none;
      background-color: white !important;
      max-height: 0;
      padding-inline-start: 0;
      overflow: hidden;
      position: absolute;
      margin: 30px 0 0;
      z-index: 1;

      li {
        display: flex;
        align-items: flex-start;
        color: $primary-color;
        width: 100%;
        cursor: pointer;
      }
    }

    #menu.down #list {
      background-color: white;
      max-height: none;
      transition: max-height 0.10s ease-in;
      box-shadow: 2px 2px 8px 2px rgba(69, 69, 69, 0.1);
    }
}

</style>
